<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="font-weight-bold text-primary">All Products</h4>
                                </div>
                            </div>
                        </div>
                        <div class=" table-responsive no-padding">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="products"
                                    :pagination-options="{
                               enabled: true,
                               mode: 'pages',
                               perPage: 10
                             }"
                                    :search-options="{
                                enabled: true,
                                placeholder: 'Search this table',
                              }">
                                <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'statu'">
                                    <span v-if="props.row.status == 0" class="badge badge-danger">out of stock</span>
                                    <span v-if="props.row.status == 1" class="badge badge-success">in stock</span>
                                </span>
                                    <span v-else-if="props.column.field == 'action'">
                                    <router-link :to="{path: '/allMyProducts/' + props.row.uniqueId}">
                                        <button type="button" class="btn btn-sm btn-primary btn-circle"
                                        >
                                    <i class="fas fa-eye"></i>
                                </button>
                                </router-link>
                                <button type="button" class="btn btn-danger btn-sm btn-circle"
                                        @click="deleteProduct(props.row.id)">
                                    <i class="fas fa-trash"></i>
                                </button>
                                </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
<script>

  export default {
    name: 'tables',
    components: {
    },
      data() {
          return {
              columns: [
                  {
                      label: 'Id#',
                      field: 'uniqueId',
                  },
                  {
                      label: 'Title',
                      field: 'title',
                  },
                  {
                      label: 'Price(Ksh)',
                      field: 'price',
                  },
                  {
                      label: 'Category',
                      field: 'category.name',
                  },
                  {
                      label: 'SubCategory',
                      field: 'subcategory.name',
                  },
                  {
                      label: 'Status',
                      field: 'statu',
                  },
                  {
                      label: 'Action',
                      field: 'action'
                  }
              ],
              products: []
          }
      },
      methods: {
          deleteProduct(id){
              this.$swal.fire({
                  title: 'Delete this Product?',
                  text: 'You wont be able to revert this!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!',
              }).then((result) => {
                  // send the request to the controller
                  if (result.value) {
                      this.axios.delete("/retailer/dashboard/delete-product/" + id).then(()=>{
                          this.$swal.fire(
                              'Success!',
                              'Product deleted successfully',
                              'success'
                          )
                          this.allProducts();
                      });
                  }
              }).catch(()=>{
                  this.$swal("Failed!", "There was something wrong.", "warning");
              })
          },
          allProducts() {
              try {
                  this.axios.get("/retailer/dashboard/all-products").then(({data}) => ([this.products = data]));
              } catch (e) {
                  throw new Error(e);
              }
          }
      },
      created() {
          this.allProducts();
      }

  };
</script>
<style></style>
